export const GET_LEAGUES_REQUEST = 'GET_LEAGUES_REQUEST';
export const GET_LEAGUES_SUCCESS = 'GET_LEAGUES_SUCCESS';
export const GET_LEAGUES_ERROR = 'GET_LEAGUES_ERROR';

export const GET_TEAMS_REQUEST = 'GET_TEAMS_REQUEST';
export const GET_TEAMS_SUCCESS = 'GET_TEAMS_SUCCESS';
export const GET_TEAMS_ERROR = 'GET_TEAMS_ERROR';

export const GET_MATCHES_REQUEST = 'GET_MATCHES_REQUEST';
export const GET_MATCHES_SUCCESS = 'GET_MATCHES_SUCCESS';
export const GET_MATCHES_ERROR = 'GET_MATCHES_ERROR';

export const GET_HIGHLIGHTS_REQUEST = 'GET_HIGHLIGHTS_REQUEST';
export const GET_HIGHLIGHTS_SUCCESS = 'GET_HIGHLIGHTS_SUCCESS';
export const GET_HIGHLIGHTS_ERROR = 'GET_HIGHLIGHTS_ERROR';

export const FETCH_REVIEW_DATA_REQUEST = 'FETCH_REVIEW_DATA_REQUEST';
export const FETCH_REVIEW_DATA_SUCCESS = 'FETCH_REVIEW_DATA_SUCCESS';
export const FETCH_REVIEW_DATA_ERROR = 'FETCH_REVIEW_DATA_ERROR';

export const FETCH_ALL_REVIEW_DATA_REQUEST = 'FETCH_ALL_REVIEW_DATA_REQUEST';
export const FETCH_ALL_REVIEW_DATA_SUCCESS = 'FETCH_ALL_REVIEW_DATA_SUCCESS';
export const FETCH_ALL_REVIEW_DATA_ERROR = 'FETCH_ALL_REVIEW_DATA_ERROR';

export const CREATE_REVIEW_DATA_REQUEST = 'CREATE_REVIEW_DATA_REQUEST';
export const CREATE_REVIEW_DATA_SUCCESS = 'CREATE_REVIEW_DATA_SUCCESS';
export const CREATE_REVIEW_DATA_ERROR = 'CREATE_REVIEW_DATA_ERROR';

export const UPDATE_REVIEW_ITEM_REQUEST = 'UPDATE_REVIEW_ITEM_REQUEST'
export const UPDATE_REVIEW_ITEM_SUCCESS = 'UPDATE_REVIEW_ITEM_SUCCESS'
export const UPDATE_REVIEW_ITEM_ERROR = 'UPDATE_REVIEW_ITEM_ERROR'

export const DELETE_REVIEW_ITEM_REQUEST='DELETE_REVIEW_ITEM_REQUEST';
export const DELETE_REVIEW_ITEM_SUCCESS ='DELETE_REVIEW_ITEM_SUCCESS';
export const DELETE_REVIEW_ITEM_ERROR ='DELETE_REVIEW_ITEM_ERROR';

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const setAuthToken = authToken => ({
    type: SET_AUTH_TOKEN,
    authToken
});

export const CLEAR_AUTH = 'CLEAR_AUTH';
export const clearAuth = () => ({
    type: CLEAR_AUTH
});

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const authRequest = () => ({
    type: AUTH_REQUEST
});

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const authSuccess = currentUser => ({
    type: AUTH_SUCCESS,
    currentUser
});

export const AUTH_ERROR = 'AUTH_ERROR';
export const authError = error => ({
    type: AUTH_ERROR,
    error
});



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js